import { cn } from '../../lib/utils';
import { Skeleton, SkeletonRegion } from '../ui/Skeleton';

interface MatterPickerSkeletonProps {
  /** `compact` is the dropdown/inline selector (`px-3 py-1.5` rows); `comfortable` is the activity wizard's step-1 list. */
  size: 'compact' | 'comfortable';
  /** Client groups to show; each holds two matter rows. */
  groups?: number;
}

/** Client-grouped matter rows: a shaded client heading over matter names. */
export function MatterPickerSkeleton({ size, groups = 2 }: MatterPickerSkeletonProps) {
  const compact = size === 'compact';
  return (
    <SkeletonRegion label="Loading matters">
      {Array.from({ length: groups }, (_, group) => (
        <div key={group}>
          <div className={cn('bg-bg-muted', compact ? 'px-3 py-1.5' : 'px-4 py-2')}>
            <Skeleton className={cn('w-1/3', compact ? 'h-4' : 'h-5')} />
          </div>
          {[0, 1].map((row) => (
            <div key={row} className={compact ? 'px-3 py-1.5' : 'px-4 py-3'}>
              <Skeleton className={cn('w-3/5', 'h-5')} />
            </div>
          ))}
        </div>
      ))}
    </SkeletonRegion>
  );
}
